import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CodeEditorComponentModule, CodeLanguage } from '@selfai-platform/pipeline-shared';
import { DialogService } from '@selfai-platform/shell';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'selfai-pipeline-variables-import-result',
  templateUrl: './variables-import-result.component.html',
  styleUrls: ['./variables-import-result.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, ButtonModule, CodeEditorComponentModule, FormsModule],
})
export class VariablesImportResultComponent implements OnInit {
  private readonly dialogService = inject(DialogService<unknown>);

  protected readonly editorContent = signal<string>('');
  protected readonly codeLanguage = CodeLanguage;

  ngOnInit(): void {
    this.editorContent.set(JSON.stringify(this.dialogService.data, null, 2));
  }

  close(): void {
    this.dialogService.close();
  }
}
